import React from 'react'
import { safeHTML } from '../../../../utils/safeHTML'
import classNames from 'classnames'
import { useUser } from '../../../../redux/reducer/user'
import { rating } from '../../../../constants/copyright'
import { useActivePremiumAchievementIcon } from '../../../../hooks/shared/achievements/useActivePremiumAchievementIcon'
import { useApplicationCallbacks } from '../../../../providers/application-callbacks'
import { useTranslation } from '../../../../translations'

const RatingItem = React.forwardRef(function (
  {
    isOutOfRating,
    index,
    score,
    uid,
    active,
    isActiveVisible,
    username,
    className,
    position,
    visible,
    iconId,
    isShowUserInfo,
    isPending = false,
  },
  ref,
) {
  const {
    profile: { uid: profileUid },
  } = useUser()
  const iconImage = useActivePremiumAchievementIcon({ extraPremiumIcon: iconId })
  const callbacks = useApplicationCallbacks()
  const { t } = useTranslation()

  const isEmployee = score === null && position === null
  const itemPosition = isEmployee ? 0 : position ?? index + 1
  const itemScore = isEmployee ? 0 : score
  const itemName = isEmployee ? t('rating.employee') : username

  return (
    <div
      className={classNames('rating__item', className, {
        rating__item_active: active,
        rating__item_user: profileUid === uid && isOutOfRating,
        rating__item_out: (position ?? index + 1) > rating.ratingCount - 1,
        rating__item_visible: visible,
        rating__item_hidden: visible === false,
        rating__item_margin: isActiveVisible === false && isShowUserInfo,
        rating__item_image: !!iconImage,
        rating__item_employee: isEmployee,
      })}
      ref={ref}
      onClick={() => !isPending && profileUid !== uid && callbacks.getFriend(uid)}
    >
      <div className={'rating__item-index'}>{itemPosition}</div>

      <div className={'rating__item-name'}>{safeHTML(itemName)}</div>

      {iconImage && (
        <img
          src={iconImage}
          className={'rating__item-image'}
          alt={''}
        />
      )}

      <div className={'rating__item-count'}>{safeHTML(itemScore)}</div>
    </div>
  )
})
export default RatingItem
RatingItem.propTypes = {}
